export default "__VITE_ASSET__9f8d6a76__"